<template>
  <div class="testimonial-carousel">
    <c-carousel v-bind="carouselOptions">
      <slot/>
    </c-carousel>
  </div>
</template>

<script>
import { DESKTOPFIRST_BREAKPOINTS, BASE_CAROUSEL_OPTIONS } from '@/components/public/content/Carousel'

const TESTIMONIAL_CAROUSEL_OPTIONS = Object.assign({}, BASE_CAROUSEL_OPTIONS, {
  adaptiveHeight: true,
  arrows: true,
  arrowsOutside: true,
  dots: false,
  slidesToShow: 2,
  slidesToScroll: 2,
  responsive: [
    {
      breakpoint: DESKTOPFIRST_BREAKPOINTS.md,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
})

export default {
  name: 'TestimonialCarousel',
  data () {
    return {
      carouselOptions: TESTIMONIAL_CAROUSEL_OPTIONS
    }
  }
}
</script>

<style lang="scss">
// mobile

// desktop
$testimonialcarousel-desktop: $desktop-breakpoint !default;

$testimonialcarousel-slide-border: map-get($borders, 'base') !default;

.testimonial-carousel {
  @include component('y');

  @include media-breakpoint-up($testimonialcarousel-desktop) {
    .carousel {
      .slick-list {
        .slick-track {
          .slick-slide {
            border-left: $testimonialcarousel-slide-border;
          }
        }
      }
    }
  }
}
</style>
